var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgChevronRight = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7079 11.28C15.8486 11.4205 15.9277 11.6111 15.9279 11.81V12.19C15.9256 12.3884 15.8468 12.5783 15.7079 12.72L10.5679 17.85C10.474 17.9446 10.3462 17.9979 10.2129 17.9979C10.0796 17.9979 9.95178 17.9446 9.8579 17.85L9.1479 17.14C9.05384 17.0478 9.00083 16.9217 9.00083 16.79C9.00083 16.6583 9.05384 16.5321 9.1479 16.44L13.5979 12L9.1479 7.55997C9.05324 7.46609 9 7.33829 9 7.20497C9 7.07166 9.05324 6.94386 9.1479 6.84997L9.8579 6.14997C9.95178 6.05532 10.0796 6.00208 10.2129 6.00208C10.3462 6.00208 10.474 6.05532 10.5679 6.14997L15.7079 11.28Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChevronRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chevron_right.fd602532.svg";
export { ForwardRef as ReactComponent };